import React from 'react';
import { Routes, Route } from 'react-router-dom';
/* import ResponsiveAppBar from './views/NavBar';
import ResponsiveFootBar from './views/FootBar'; */
import { Box } from '@mui/material';
import PrivacyPolicy from './views/PrivacyPolicy.js';
import TermsAndConditions from './views/TermsAndConditions.js';
import MarketMonitorLegal from './views/MarketMonitorLegal/marketMonitorLegal.js';
import MarketFirm from './views/MarketMonitorLegal/marketFirm.js';
import MarketComparativeLegal from './views/MarketMonitorLegal/marketComparativeLegal.js';
import Methodology from './views/MarketMonitorLegal/Methodology';

const App = () => {

  return (
    <>
      {/* <ResponsiveAppBar /> */}
      <Box sx={{ minHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
        <Routes>
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms-and-conditions' element={<TermsAndConditions />} />

          {/* Market Monitor Legal*/}
          <Route path='/' element={<MarketMonitorLegal />} />
          <Route path='/market-monitor-legal' element={<MarketMonitorLegal />} />
          <Route path='/market-monitor-legal/metodology' element={<Methodology />} />
          <Route path='/market-firm/:countrySlug/:firmSlug' element={<MarketFirm />} />
          <Route path='/market-firm/:firmSlug' element={<MarketFirm />} />
          <Route path='/market-comparative-legal/:countrySlug/:firmSlug' element={<MarketComparativeLegal />} />
          <Route path='/market-comparative-legal/:firmSlug' element={<MarketComparativeLegal />} />

        </Routes>
      </Box>
      {/* <ResponsiveFootBar /> */}
    </>
  );
};

export default App;
